import { PLACEHOLDER } from "./site";

// Each service: bilingual slugs + full AI-readable Q&A structure
export const SERVICES = [
  {
    key: "individual",
    icon: "User",
    slug: { id: "konseling-individu", en: "individual-counseling" },
    name: { id: "Konseling Individu", en: "Individual Counseling" },
    short: {
      id: "Dukungan profesional untuk tantangan pribadi, emosional, dan psikologis.",
      en: "Professional support for personal, emotional and psychological challenges.",
    },
    what: {
      id: "Konseling individu adalah sesi tatap muka antara Anda dan psikolog untuk membahas tantangan pribadi, emosional, atau psikologis dalam lingkungan yang privat dan tanpa penghakiman. Tujuannya adalah memahami situasi Anda dan menyusun langkah yang sesuai dengan kebutuhan Anda.",
      en: "Individual counseling is a one-on-one session between you and a psychologist to discuss personal, emotional or psychological challenges in a private, non-judgmental setting. The goal is to understand your situation and develop steps that fit your needs.",
    },
    who: {
      id: "Individu dewasa yang menghadapi kecemasan, stres, burnout, kesulitan emosional, masalah kepercayaan diri, transisi hidup, atau tekanan pekerjaan.",
      en: "Adults facing anxiety, stress, burnout, emotional difficulties, self-esteem concerns, life transitions or work-related pressure.",
    },
    when: {
      id: ["Kesulitan emosional mulai mengganggu aktivitas sehari-hari", "Merasa cemas, tertekan, atau kelelahan secara berkepanjangan", "Menghadapi perubahan hidup yang besar", "Ingin memahami diri sendiri secara lebih baik"],
      en: ["Emotional difficulties start affecting daily life", "Feeling anxious, low or exhausted for an extended period", "Facing a major life change", "Wanting to understand yourself better"],
    },
    firstSession: {
      id: "Pada sesi pertama, psikolog akan mendengarkan cerita Anda, memahami kebutuhan dan tujuan Anda, lalu mendiskusikan rencana pendampingan yang sesuai. Tidak ada persiapan khusus yang diperlukan.",
      en: "In the first session, your psychologist listens to your story, explores your needs and goals, and discusses a suitable support plan. No special preparation is required.",
    },
  },
  {
    key: "couples",
    icon: "Heart",
    slug: { id: "konseling-pasangan", en: "couples-counseling" },
    name: { id: "Konseling Pasangan", en: "Couples Counseling" },
    short: {
      id: "Dukungan profesional untuk komunikasi, konflik, dan tantangan hubungan.",
      en: "Professional support for communication, conflict and relationship challenges.",
    },
    what: {
      id: "Konseling pasangan membantu dua orang dalam suatu hubungan memahami pola komunikasi, mengelola konflik, dan membangun kembali koneksi dengan pendampingan psikolog yang netral.",
      en: "Couples counseling helps two people in a relationship understand communication patterns, manage conflict and rebuild connection with the guidance of a neutral psychologist.",
    },
    who: {
      id: "Pasangan yang mengalami konflik berulang, kesulitan komunikasi, perbedaan nilai, atau perubahan dalam hubungan.",
      en: "Couples experiencing recurring conflict, communication difficulties, differences in values, or changes in their relationship.",
    },
    when: {
      id: ["Konflik yang sama terus berulang", "Komunikasi terasa buntu", "Kepercayaan sedang diuji", "Ingin memperkuat hubungan sebelum masalah membesar"],
      en: ["The same conflict keeps repeating", "Communication feels stuck", "Trust is being tested", "You want to strengthen the relationship before issues grow"],
    },
    firstSession: {
      id: "Sesi pertama berfokus pada memahami perspektif kedua pihak dan tujuan bersama. Psikolog bersikap netral dan tidak memihak.",
      en: "The first session focuses on understanding both perspectives and shared goals. The psychologist remains neutral and does not take sides.",
    },
  },
  {
    key: "family",
    icon: "Users",
    slug: { id: "konseling-keluarga", en: "family-counseling" },
    name: { id: "Konseling Keluarga", en: "Family Counseling" },
    short: {
      id: "Dukungan untuk komunikasi, konflik, dan dinamika hubungan keluarga.",
      en: "Support for family communication, conflict and relationship dynamics.",
    },
    what: {
      id: "Konseling keluarga membantu anggota keluarga memahami dinamika, memperbaiki komunikasi, dan menyelesaikan konflik dengan pendekatan yang terstruktur dan suportif.",
      en: "Family counseling helps family members understand dynamics, improve communication and resolve conflict through a structured, supportive approach.",
    },
    who: {
      id: "Keluarga yang menghadapi konflik, perubahan besar (perpindahan, perceraian, kehilangan), atau kesulitan komunikasi antar generasi.",
      en: "Families facing conflict, major transitions (relocation, divorce, loss) or intergenerational communication difficulties.",
    },
    when: {
      id: ["Konflik keluarga memengaruhi keseharian", "Komunikasi antar anggota keluarga terputus", "Menghadapi perubahan besar bersama-sama", "Kekhawatiran terhadap salah satu anggota keluarga"],
      en: ["Family conflict affects daily life", "Communication between members has broken down", "Facing a major transition together", "Concerns about one family member"],
    },
    firstSession: {
      id: "Psikolog akan memahami situasi dari sudut pandang setiap anggota keluarga yang hadir, lalu menyusun pendekatan yang sesuai.",
      en: "The psychologist explores the situation from each attending family member's perspective, then shapes an appropriate approach.",
    },
  },
  {
    key: "child",
    icon: "Baby",
    slug: { id: "konseling-anak-remaja", en: "child-adolescent-counseling" },
    name: { id: "Konseling Anak & Remaja", en: "Child & Adolescent Counseling" },
    short: {
      id: "Dukungan psikologis yang disesuaikan untuk anak-anak dan remaja.",
      en: "Psychological support tailored to children and teenagers.",
    },
    what: {
      id: "Konseling anak dan remaja menggunakan pendekatan yang sesuai usia untuk membantu anak dan remaja mengelola emosi, perilaku, dan tantangan perkembangan, dengan pelibatan orang tua bila diperlukan.",
      en: "Child and adolescent counseling uses age-appropriate approaches to help young people manage emotions, behavior and developmental challenges, involving parents where helpful.",
    },
    who: {
      id: "Anak dan remaja dengan kekhawatiran emosi, perilaku, sekolah, pertemanan, atau perkembangan; serta orang tua yang membutuhkan panduan.",
      en: "Children and teenagers with emotional, behavioral, school, social or developmental concerns; and parents seeking guidance.",
    },
    when: {
      id: ["Perubahan perilaku atau emosi yang mencolok", "Kesulitan di sekolah atau pertemanan", "Kecemasan atau penarikan diri", "Orang tua membutuhkan panduan pengasuhan"],
      en: ["Noticeable changes in behavior or mood", "Difficulties at school or with friends", "Anxiety or withdrawal", "Parents needing parenting guidance"],
    },
    firstSession: {
      id: "Sesi pertama biasanya melibatkan orang tua untuk memahami latar belakang, dilanjutkan pendekatan yang ramah anak sesuai usia.",
      en: "The first session usually involves parents to understand the background, followed by a child-friendly, age-appropriate approach.",
    },
  },
  {
    key: "premarital",
    icon: "Sparkles",
    slug: { id: "konseling-pranikah", en: "premarital-counseling" },
    name: { id: "Konseling Pranikah", en: "Premarital Counseling" },
    short: {
      id: "Persiapan psikologis untuk pasangan sebelum memasuki pernikahan.",
      en: "Psychological preparation for couples before marriage.",
    },
    what: {
      id: "Konseling pranikah membantu pasangan membangun fondasi pernikahan yang sehat dengan membahas ekspektasi, komunikasi, nilai, keuangan, dan rencana keluarga bersama psikolog.",
      en: "Premarital counseling helps couples build a healthy foundation for marriage by exploring expectations, communication, values, finances and family plans with a psychologist.",
    },
    who: {
      id: "Pasangan yang berencana menikah dan ingin mempersiapkan hubungan jangka panjang secara sehat.",
      en: "Couples planning to marry who want to prepare a healthy long-term relationship.",
    },
    when: {
      id: ["Sebelum menetapkan tanggal pernikahan", "Saat ada perbedaan nilai atau ekspektasi", "Ingin membangun pola komunikasi yang sehat sejak awal"],
      en: ["Before setting a wedding date", "When values or expectations differ", "To build healthy communication patterns early"],
    },
    firstSession: {
      id: "Psikolog akan memetakan harapan dan kekhawatiran masing-masing pihak serta area yang ingin diperkuat.",
      en: "The psychologist maps each partner's hopes and concerns and the areas you want to strengthen.",
    },
  },
  {
    key: "marriage",
    icon: "HeartHandshake",
    slug: { id: "konseling-pernikahan", en: "marriage-counseling" },
    name: { id: "Konseling Pernikahan", en: "Marriage Counseling" },
    short: {
      id: "Pendampingan profesional untuk tantangan dalam pernikahan.",
      en: "Professional support for challenges within marriage.",
    },
    what: {
      id: "Konseling pernikahan membantu suami istri mengatasi kesulitan pernikahan seperti konflik berkepanjangan, komunikasi yang memburuk, atau perubahan besar dalam kehidupan rumah tangga.",
      en: "Marriage counseling helps spouses address marital difficulties such as prolonged conflict, deteriorating communication or major changes in married life.",
    },
    who: {
      id: "Pasangan menikah yang ingin memperbaiki, memperkuat, atau mengevaluasi hubungan mereka secara sehat.",
      en: "Married couples who want to repair, strengthen or healthily evaluate their relationship.",
    },
    when: {
      id: ["Konflik pernikahan terasa berlarut-larut", "Komunikasi memburuk", "Peristiwa besar mengguncang rumah tangga", "Mempertimbangkan langkah besar dalam pernikahan"],
      en: ["Marital conflict feels prolonged", "Communication is deteriorating", "A major event has shaken the marriage", "Considering major decisions about the marriage"],
    },
    firstSession: {
      id: "Sesi pertama memetakan kondisi pernikahan dari kedua sudut pandang dan menetapkan tujuan bersama yang realistis.",
      en: "The first session maps the state of the marriage from both perspectives and sets realistic shared goals.",
    },
  },
  {
    key: "trauma",
    icon: "ShieldCheck",
    slug: { id: "konseling-trauma", en: "trauma-counseling" },
    name: { id: "Konseling Trauma", en: "Trauma Counseling" },
    short: {
      id: "Pendampingan psikologis untuk pemulihan dari pengalaman traumatis.",
      en: "Psychological support for recovery from traumatic experiences.",
    },
    what: {
      id: "Konseling trauma memberikan ruang yang aman dan terstruktur untuk memproses pengalaman traumatis dengan pendekatan yang sesuai secara klinis dan berjalan sesuai kesiapan Anda.",
      en: "Trauma counseling provides a safe, structured space to process traumatic experiences using clinically appropriate approaches, at a pace guided by your readiness.",
    },
    who: {
      id: "Individu yang mengalami dampak berkelanjutan dari peristiwa traumatis seperti kecelakaan, kehilangan, kekerasan, atau pengalaman masa kecil.",
      en: "Individuals experiencing ongoing effects of traumatic events such as accidents, loss, violence or childhood experiences.",
    },
    when: {
      id: ["Ingatan atau mimpi yang mengganggu terus muncul", "Menghindari situasi tertentu karena pengalaman masa lalu", "Perasaan waspada atau tegang yang berlebihan", "Pengalaman masa lalu memengaruhi hubungan atau pekerjaan"],
      en: ["Intrusive memories or dreams keep recurring", "Avoiding situations due to past experiences", "Excessive alertness or tension", "Past experiences affecting relationships or work"],
    },
    firstSession: {
      id: "Sesi pertama berfokus pada rasa aman dan kenyamanan. Anda tidak akan diminta menceritakan detail sebelum siap.",
      en: "The first session focuses on safety and comfort. You will not be asked to share details before you are ready.",
    },
  },
  {
    key: "assessment",
    icon: "ClipboardList",
    slug: { id: "asesmen-psikologi", en: "psychological-assessment" },
    name: { id: "Asesmen Psikologi", en: "Psychological Assessment" },
    short: {
      id: "Tes dan asesmen psikologi profesional oleh psikolog.",
      en: "Professional psychological testing and assessment by psychologists.",
    },
    what: {
      id: "Asesmen psikologi adalah proses evaluasi terstruktur menggunakan wawancara klinis, observasi, dan alat tes psikologi terstandar untuk memahami aspek kognitif, emosi, kepribadian, atau perkembangan seseorang.",
      en: "Psychological assessment is a structured evaluation using clinical interviews, observation and standardized psychological tests to understand a person's cognitive, emotional, personality or developmental profile.",
    },
    who: {
      id: "Individu, anak, remaja, atau keluarga yang membutuhkan pemahaman objektif untuk keperluan klinis, pendidikan, atau pengembangan diri.",
      en: "Individuals, children, adolescents or families needing an objective understanding for clinical, educational or personal development purposes.",
    },
    when: {
      id: ["Membutuhkan gambaran objektif tentang kondisi psikologis", "Kekhawatiran tumbuh kembang anak", "Kebutuhan rekomendasi pendidikan atau pengembangan", "Menunjang proses konseling yang lebih terarah"],
      en: ["Needing an objective picture of psychological functioning", "Concerns about a child's development", "Educational or development recommendations", "Supporting a more targeted counseling process"],
    },
    firstSession: {
      id: "Diawali wawancara awal untuk memahami tujuan asesmen, dilanjutkan sesi pengetesan, dan diakhiri sesi penjelasan hasil oleh psikolog.",
      en: "It begins with an intake interview to clarify the assessment goals, followed by testing sessions and a results discussion with the psychologist.",
    },
  },
  {
    key: "programs",
    icon: "Route",
    slug: { id: "program-kesehatan-mental", en: "mental-health-programs" },
    name: { id: "Program Kesehatan Mental", en: "Mental Health Programs" },
    short: {
      id: "Program terstruktur yang dirancang untuk kebutuhan psikologis tertentu.",
      en: "Structured programs designed around specific psychological needs.",
    },
    what: {
      id: "Program kesehatan mental adalah rangkaian sesi terstruktur yang dirancang psikolog untuk kebutuhan spesifik, dengan tujuan, tahapan, dan evaluasi yang jelas.",
      en: "Mental health programs are structured series of sessions designed by psychologists for specific needs, with clear goals, stages and evaluation.",
    },
    who: {
      id: "Individu, pasangan, atau keluarga yang membutuhkan pendampingan lebih terstruktur daripada sesi konseling tunggal.",
      en: "Individuals, couples or families who need more structured support than single counseling sessions.",
    },
    when: {
      id: ["Kebutuhan berkelanjutan yang memerlukan rencana bertahap", "Ingin bekerja pada tujuan spesifik secara terukur", "Direkomendasikan setelah konsultasi awal"],
      en: ["Ongoing needs requiring a staged plan", "Working on specific goals in a measurable way", "Recommended after an initial consultation"],
    },
    firstSession: {
      id: "Program selalu diawali konsultasi untuk memastikan program yang dipilih sesuai dengan kebutuhan Anda.",
      en: "Every program begins with a consultation to ensure the chosen program fits your needs.",
    },
  },
  {
    key: "online",
    icon: "Video",
    slug: { id: "konseling-online", en: "online-counseling" },
    name: { id: "Konseling Online", en: "Online Counseling" },
    short: {
      id: "Sesi konseling jarak jauh dari mana pun Anda berada di Bali maupun luar Bali.",
      en: "Remote counseling sessions from wherever you are, in Bali or beyond.",
    },
    what: {
      id: "Konseling online adalah sesi konseling yang dilakukan secara jarak jauh melalui panggilan video atau media daring lainnya, dengan psikolog yang sama dan standar kerahasiaan yang sama seperti sesi di klinik.",
      en: "Online counseling is a counseling session conducted remotely via video call or other online media, with the same psychologists and the same confidentiality standards as in-clinic sessions.",
    },
    who: {
      id: "Individu atau pasangan dengan mobilitas terbatas, jadwal padat, berdomisili jauh dari Denpasar, atau yang lebih nyaman berkonsultasi dari rumah.",
      en: "Individuals or couples with limited mobility, busy schedules, living far from Denpasar, or who feel more comfortable consulting from home.",
    },
    when: {
      id: ["Sulit datang langsung ke klinik di Renon", "Berdomisili di luar Denpasar atau luar Bali", "Jadwal yang tidak memungkinkan perjalanan", "Lebih nyaman memulai dari ruang pribadi Anda"],
      en: ["It is difficult to visit the clinic in Renon", "You live outside Denpasar or outside Bali", "Your schedule does not allow travel", "You feel more comfortable starting from your own space"],
    },
    firstSession: {
      id: "Setelah booking dikonfirmasi, tim kami mengirimkan tautan atau instruksi sesi melalui WhatsApp. Siapkan tempat yang tenang dan privat, koneksi internet stabil, dan perangkat dengan kamera.",
      en: "Once your booking is confirmed, our team sends the session link or instructions via WhatsApp. Prepare a quiet, private space, a stable internet connection and a device with a camera.",
    },
  },
  {
    key: "offline",
    icon: "Building2",
    slug: { id: "konseling-offline", en: "offline-counseling" },
    name: { id: "Konseling Offline (Tatap Muka)", en: "Offline (In-Person) Counseling" },
    short: {
      id: "Sesi tatap muka langsung di klinik kami di Renon, Denpasar Selatan.",
      en: "Face-to-face sessions at our clinic in Renon, Denpasar Selatan.",
    },
    what: {
      id: "Konseling offline adalah sesi konseling tatap muka yang dilakukan langsung di klinik Bali Empower — di lantai 2 gedung Apotik Indobat, Jl. Tukad Yeh Aya No. 100, Renon — dalam ruang konsultasi yang privat dan nyaman.",
      en: "Offline counseling is a face-to-face session held at the Bali Empower clinic — on the 2nd floor of the Apotik Indobat building, Jl. Tukad Yeh Aya No. 100, Renon — in a private, comfortable consultation room.",
    },
    who: {
      id: "Siapa pun yang lebih nyaman bertemu langsung, serta layanan yang paling efektif dilakukan tatap muka seperti konseling anak, sesi keluarga, dan asesmen psikologi.",
      en: "Anyone who prefers meeting in person, as well as services most effective face-to-face such as child counseling, family sessions and psychological assessment.",
    },
    when: {
      id: ["Lebih nyaman berbicara secara langsung", "Sesi keluarga atau pasangan yang dihadiri bersama", "Asesmen psikologi yang memerlukan pengetesan langsung", "Menginginkan ruang yang benar-benar terpisah dari rumah"],
      en: ["You prefer talking in person", "Family or couple sessions attended together", "Psychological assessment requiring in-person testing", "You want a space fully separate from home"],
    },
    firstSession: {
      id: "Datanglah beberapa menit sebelum jadwal Anda ke lantai 2 Apotik Indobat. Jam praktik: Senin–Jumat 10.00–22.00, Sabtu & Minggu 12.00–22.00.",
      en: "Arrive a few minutes before your schedule at the 2nd floor of Apotik Indobat. Practice hours: Monday–Friday 10:00–22:00, Saturday & Sunday 12:00–22:00.",
    },
  },
];

export const serviceCommon = {
  duration: {
    id: "Umumnya 60 menit per sesi. Sesi bersama pasangan atau keluarga berlangsung 90–120 menit.",
    en: "Generally 60 minutes per session. Joint couple or family sessions run 90–120 minutes.",
  },
  sessions: {
    id: "Jumlah sesi berbeda untuk setiap orang dan akan didiskusikan bersama psikolog setelah sesi pertama.",
    en: "The number of sessions differs for each person and is discussed with your psychologist after the first session.",
  },
  provider: {
    id: "Layanan diberikan oleh tenaga profesional psikologi Bali Empower. [Profil tim akan dilengkapi oleh tim Bali Empower]",
    en: "Services are provided by Bali Empower's psychology professionals. [Team profiles to be completed by the Bali Empower team]",
  },
  format: {
    id: "Konseling tersedia secara offline (tatap muka) di klinik kami di Renon, Denpasar Selatan, maupun secara online. Sampaikan metode yang Anda inginkan saat booking.",
    en: "Counseling is available offline (in person) at our clinic in Renon, Denpasar Selatan, as well as online. Let us know your preferred method when booking.",
  },
  cost: {
    id: "Biaya konseling mulai dari Rp 250.000 per sesi 60 menit, tergantung jenis layanan. Rincian biaya dapat ditanyakan melalui WhatsApp di 087777430348.",
    en: "Counseling fees start from Rp 250,000 per 60-minute session, depending on the service. Detailed fees are available via WhatsApp at 087777430348.",
  },
  booking: {
    id: "Anda dapat membuat janji melalui formulir booking di website ini atau langsung melalui WhatsApp di 087777430348.",
    en: "You can book through the booking form on this website or directly via WhatsApp at 087777430348.",
  },
};

export const findService = (lang, slug) =>
  SERVICES.find((s) => s.slug[lang] === slug);
